module.exports = __webpack_public_path__ + "roadmap-1-2x-fe00a6685df5450f70c43ac466f81dbd.webp";